











































































































































import { Component } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import PicModal from '@/components/upload/picModal.vue'
import Api from '@/api/marketing/live/index'

@Component({
  components: {
    PicModal,
  },
})
export default class EditCompany extends AbpBase {
  form = {
    roomId: null, // 直播间id
    name: null, // 直播间名称
    coverImg: null, // 直播间背景图
    startTime: null, // 开始时间
    endTime: null, // 结束时间
    anchorName: null, // 主播昵称
    anchorWechat: null, // 主播微信号
    shareImg: null, // 分享图
    feedsImg: null, // 购物直播频道封面图
    isFeedsPublic: false, // 是否开启官方收录
    screenType: 0, // 观看方式
    closeLike: false, // 是否关闭点赞
    closeGoods: false, // 是否关闭货架
    closeComment: false, // 是否关闭评论
    closeReplay: false, // 是否关闭回放
    closeShare: false, // 是否关闭分享
    closeKf: false, // 是否关闭客服
    liveStatus: -1, // 直播间状态
    type: 0,
  }
  btnLoading: boolean = false
  ruleForm = {
    name: [{ required: true, message: '请输入直播间名称', trigger: 'blur' }],
    coverImg: [{ required: true, message: '请选择直播间背景图', trigger: 'blur' }],
    startTime: [
      {
        required: true,
        type: 'date',
        message: '请选择开始时间',
        trigger: 'change',
      },
    ],
    // startTime: [{ required: true,validator: this.validBeginTime, trigger: 'change' }],
    endTime: [
      {
        required: true,
        type: 'date',
        message: '请选择结束时间',
        trigger: 'change',
      },
    ],
    // endTime: [{ required: true, validator: this.validEndTime, trigger: 'change' }],
    anchorName: [{ required: true, message: '请输入主播昵称', trigger: 'blur' }],
    anchorWechat: [{ required: true, message: '请输入主播微信号', trigger: 'blur' }],
    shareImg: [{ required: true, message: '请选择分享图', trigger: 'blur' }],
    feedsImg: [{ required: true, message: '请选择购物直播频道封面图', trigger: 'blur' }],
  }
  validBeginTime(rule, value, callback) {
    if (value === '') {
      callback(new Error('请选择开始日期'))
    } else {
      ;(this.$refs as any).form.validateField('endTime')
    }
    callback()
  }
  validEndTime(rule, value, callback) {
    if (value === '') {
      callback(new Error('请选择结束日期'))
    }
    if (value < this.form.startTime) {
      callback(new Error('结束日期必须大于开始日期'))
    }
    callback()
  }
  created() {
    if (this.$route.query.id) {
      this.getLiveRoomInfo()
    }
  }

  /**
   * 获取直播间信息
   */
  getLiveRoomInfo() {
    let id = this.$route.query['id']
    if (id) {
      console.log(id)
      Api.getLiveRoomInfoById(this.$route.query['id'].toString()).then((res) => {
        console.log('直播间信息', res)
        res.data.screenType = res.data.screenType ? 1 : 0
        this.form = res.data
        this.form.startTime = new Date(res.data.startTime)
        this.form.endTime = new Date(res.data.endTime)
      })
    }
  }
  /**
   * 选择直播间背景图图片
   */
  picChangeCoverImg(event) {
    console.log(event)
    this.form.coverImg = event[0].url
  }
  /**
   * 选择直播间分享图图片
   */
  picChangeShareImg(event) {
    console.log(event)
    this.form.shareImg = event[0].url
  }
  /**
   * 选择购物车频道封面图
   */
  picChangeFeedsImg(event) {
    console.log(event)
    this.form.feedsImg = event[0].url
  }
  submit() {
    let vm = this
    let form: any = vm.$refs.form
    form.validate((valid) => {
      if (valid) {
        this.btnLoading = true
        if (this.$route.query.id) {
          let id = this.$route.query.id
          Api.updatedLiveRoomInfoById(id.toString(), vm.form)
            .then((res) => {
              console.log('修改直播间', res)
              this.$Notice.success({ desc: '修改成功' })
              this.btnLoading = false
              this.$router.replace({
                name: 'liveRoomList',
              })
            })
            .catch((r) => {
              this.btnLoading = false
            })
        } else {
          Api.createLiveRoom(vm.form)
            .then((res) => {
              console.log('创建直播间', res)
              this.$Notice.success({ desc: '创建成功' })
              this.btnLoading = false
              this.$router.replace({
                name: 'liveRoomList',
              })
            })
            .catch((r) => {
              this.btnLoading = false
            })
        }
      }
    })
  }
  cancel() {}
}
